import { useEffect } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { useScrollToHash } from '@/hooks/useScrollToHash';
import { injectBreadcrumbSchema, injectFaqSchema } from '@/utils/structuredData';
import { applyPageSeo } from '@/utils/seo';
import Hero from './components/Hero';
import EngineAnatomy from './components/EngineAnatomy';
import StepObserve from './components/StepObserve';
import StepEvaluate from './components/StepEvaluate';
import StepWaiting from './components/StepWaiting';
import StepDecision from './components/StepDecision';
import StepDirection from './components/StepDirection';
import StepRiskCheck from './components/StepRiskCheck';
import StepExecute from './components/StepExecute';
import LoopBackBand from './components/LoopBackBand';
import StepManage from './components/StepManage';
import StepClose from './components/StepClose';
import StepRecord from './components/StepRecord';
import ProcessNumbers from './components/ProcessNumbers';
import RiskReality from './components/RiskReality';
import SystemLoop from './components/SystemLoop';
import StepTracker from './components/StepTracker';
import HowFaq, { faqs } from './components/HowFaq';

const pageTitle = 'How It Works | XAUUSD MT5 Expert Advisor | GoldEA';
const pageDescription =
  'See how the GoldEA XAUUSD Expert Advisor works — reading the gold market, checking conditions, deciding entries, executing on MT5 and managing every position.';
const pageKeywords =
  'XAUUSD EA logic, MT5 Expert Advisor, gold trade decision flow, rule-based gold trading';

export default function HowItWorks() {
  useScrollToHash();

  useEffect(() => {
    const removeSeo = applyPageSeo({
      title: pageTitle,
      description: pageDescription,
      keywords: pageKeywords,
      path: '/how-it-works',
    });
    const removeBreadcrumb = injectBreadcrumbSchema('How It Works', '/how-it-works');
    const removeFaq = injectFaqSchema(faqs);
    return () => {
      removeSeo();
      removeBreadcrumb();
      removeFaq();
    };
  }, []);

  return (
    <div className="w-full min-h-screen bg-background-50">
      <SiteHeader current="how-it-works" />
      <StepTracker />
      <main>
        <Hero />
        <EngineAnatomy />
        <StepObserve />
        <StepEvaluate />
        <StepWaiting />
        <StepDecision />
        <StepDirection />
        <StepRiskCheck />
        <StepExecute />
        <LoopBackBand />
        <StepManage />
        <StepClose />
        <StepRecord />
        <ProcessNumbers />
        <RiskReality />
        <SystemLoop />
        <HowFaq />
      </main>
      <SiteFooter current="how-it-works" />
    </div>
  );
}